import { createContext, useContext } from 'react';
export const ActivityFeedContext = createContext(null);
export const useActivityFeedContext = () => {
    const context = useContext(ActivityFeedContext);
    if (!context) {
        throw new Error('useActivityFeedContext must be used within an ActivityFeed component');
    }
    return context;
};
